import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'timestampFormat',
})
export class TimestampFormatPipe implements PipeTransform {
  transform(timestamp: string, timezone?: string): string {
    if (!timestamp) return ''

    // Ensure timestamp is treated as UTC by appending 'Z' if no timezone info present
    let utcTimestamp = timestamp
    if (!timestamp.endsWith('Z') && !timestamp.includes('+') && !timestamp.includes('T')) {
      // Replace space with 'T' for ISO format and add 'Z' for UTC
      utcTimestamp = timestamp.replace(' ', 'T') + 'Z'
    } else if (!timestamp.endsWith('Z') && timestamp.includes('T') && !timestamp.includes('+')) {
      utcTimestamp = timestamp + 'Z'
    }

    const date = new Date(utcTimestamp)
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    }

    // If timezone is specified, use it; otherwise use local timezone
    if (timezone) {
      options.timeZone = timezone
    }

    return new Intl.DateTimeFormat('en-US', options).format(date)
  }
}
